function nativeIdentityPlugin(provider, win = typeof window !== 'undefined' ? window : null) {
  if (!['google', 'facebook'].includes(provider) || !win?.Capacitor?.isNativePlatform?.() || !win.KelimoNative?.features?.[provider] ||
      !win.Capacitor.isPluginAvailable?.('FirebaseAuthentication')) return null;
  return win.KelimoNative.identity || win.Capacitor.registerPlugin?.('FirebaseAuthentication') || null;
}
async function nativeIdentityCredential(provider, plugin = nativeIdentityPlugin(provider)) {
  if (!plugin) throw new Error('Bu cihazda sosyal giriş henüz yapılandırılmadı.');
  const result = provider === 'google' ? await plugin.signInWithGoogle({ skipNativeAuth: true }) : provider === 'facebook' ? await plugin.signInWithFacebook({ skipNativeAuth: true }) : null;
  const credential = result?.credential;
  if (credential?.providerId && credential.providerId !== `${provider}.com`) throw new Error('Kimlik sağlayıcısı eşleşmedi.');
  const value = provider === 'google' ? credential?.idToken : credential?.accessToken;
  // Firebase's own ID token is NOT a Google credential. Only the provider credential is sent to the existing verifier.
  if (typeof value !== 'string' || value.length < (provider === 'google' ? 40 : 10) || value.length > (provider === 'google' ? 8192 : 4096)) throw new Error('Sosyal giriş kimliği alınamadı.');
  return value;
}
module.exports = { nativeIdentityPlugin, nativeIdentityCredential };
